import config from './dashboard/config'
import log from './dashboard/log'

export default {
  ...config,
  ...log
}



// WEBPACK FOOTER //
// ./src/locales/lang/en-US/dashboard.js